import { render, staticRenderFns } from "./ClinicGrid.vue?vue&type=template&id=2ed33214"
import script from "./ClinicGrid.vue?vue&type=script&lang=js"
export * from "./ClinicGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports